// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.host-div {
  display: flex;
  flex-direction: row;
  height: 100vh;
  background: #F8F8F8;
}
.title-1 {
  text-align: left;
  font-size: 20px !important;
  height: 26px;
  font-weight: 500 !important;
  letter-spacing: 0;
  margin-top: 48px;
  margin-bottom: 0;
  color: #444444;
  opacity: 1
}

.title-spacing {
  margin-top: 24px
}

.input-info-col {
  margin-right: 24px
}

.top-heading {
  /* position: relative; */
  font-size: 28px;
  min-height: 37px;
  font-weight: 500;
  margin-top: 12px;
  margin-bottom: 0;
  letter-spacing: 0;
  color: #212121;
  opacity: 1;
}

.header-padding-override {
  padding: 40px 20px !important
}

.top-title {
  text-align: left;
  font-size: 12px;
  height: 16px;

  letter-spacing: 0.96px;
  color: #CCC;
  text-transform: uppercase;
  opacity: 1;
}

.top-description {
  /* position: relative; */
  text-align: left;

  font-size: 16px;
  letter-spacing: 0;
  color: #888;
  margin-top: 40px;
  margin-bottom: 0;
  min-height: 45px;
  height: auto;
  opacity: 1;
}

.progress-color {
  color: grey !important;
}

.warning-msg {
  text-align: left;
  font-size: 11px !important;

  letter-spacing: 0;
  color: #AAAAAA;
  opacity: 1;
}

.horizontal-line {
  margin-top: 40px;
  margin-bottom: 0;
  border-top: 1px solid #eee;
  border-bottom: none;
}

.remove-icon:hover {
  cursor: pointer;
}

.profile-card-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow-y: auto;
  position: relative;
  padding: 0 48px;
}

.profile-card-container .ant-radio-checked:after {
  content: initial;
}

.flex {
  flex: 1 0 0;
}

.logo-header {
  width: 80px;
  height: auto;
  opacity: 1;
}

.profile-card {
  width: 100%;
  max-width: 602px;
  padding: 0 !important;
  background: #F8F8F8;
}

.profile-card > .ant-card-body {
  padding: 0 !important
}

.btn-link-font {
  text-align: left;

  font-size: 16px !important;
  letter-spacing: 0;
  color: #212121;
  opacity: 1;
}
 /* Aside */

 aside{
  background-color: #EEEEEE;
  width: 366px;
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
  padding: 0 !important;
  overflow: hidden;
  overflow-y: auto;
  border-left: 1px solid #eee;
}

.ant-input::placeholder, .ant-input:placeholder-shown {
  text-overflow: ellipsis;
  color: #bfbfbf;
  font-size: 16px;
  opacity: 0.6;
}

@media only screen and (max-width: 1400px){ 
  /* aside{
    width: 260px;
  } */
}

.aside_logo {
  margin-top: 48px;
  margin-bottom: 20px;
  align-self: flex-end;
  width: 55px;
  height: auto;
}

#aside_tagline {
  font-size: 20px;
  font-weight: 500;
  color: #000000;
  text-align: right;
  width: 180px;
  align-self: flex-end;
}
#aside_cards{
  margin: 24px 0;
}
.aside_card{
  box-shadow: 0 2px 4px rgba(0,0,0,0.08);
  padding: 12px 16px;
  background-color: white;
  border-radius: 4px;
  color: #444;
  font-size: 14px;
  margin-bottom: 16px;
}
#aside_illustration{
  margin-bottom: 56px;
  width: 150%;
  height: auto;
}

.section-title {
  display: flex;
  align-items: baseline;
}
.section-warning {
  margin-top: 48px;
  margin-left: 18px;
  text-align: left;
  height: 26px;
  letter-spacing: 0;
  margin-bottom: 0;
  opacity: 1
}

.link-text {
  color: #AAAAAA !important;
  text-decoration: underline !important;
}

.summary-description {
  text-align: left;
  
  font-size: 14px;
  letter-spacing: 0;
  color: #888888 !important;
  margin-top: 24px;
  margin-bottom: 24px;
}


.header-center{
  flex: 1;
  width: 100%;
  max-width: 602px;
  padding: 0 !important;
  display: flex;
  align-items: center;
}

.header-left, .header-right {
  width: 80px;
  display: flex;
}

.header-right {
  justify-content: flex-end;
}

.header-center-title{
  flex: 1;
  color: #888888;
  font-size: 16px;
}
.header-center-progress{
  width: 220px;
}

.resume-upload-heading {

  font-size: 20px;
  line-height: 30px;
  letter-spacing: 0.25px;
  color: #212121;
  margin-bottom: 8px !important;
}

.resume-upload-description {

  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  letter-spacing: 0.15px;
  color: #212121;
  margin-bottom: 32px;
}

.upload-container {
  background: #FFFFFF;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.12);
  border-radius: 8px;
  padding: 24px;
}

.upload-container .ant-upload.ant-upload-drag {
  background: #F8F8F8;
  border-radius: 6px;
  border: 1px solid #56A8F7;
  height: 180px;
}
.resume-upload-cont {
  margin-bottom: 32px;
}

.resume-upload-cont.error .ant-upload.ant-upload-drag {
  border: 1px solid #F86567;
}

.upload-container .error {

  font-size: 12px;
  line-height: 17px;
  color: red;
  margin-top: 4px;
  display: block;
}

.linkedin-url-input-cont{
  margin-bottom: 16px;
}

.linkedin-url-input-cont input
{
  height: 38px;
  padding: 9px 12px 7px 36px !important;
  font-size: 14px;
}

.linkedin-url-input-cont.error input {
  border: 1px solid #F86567 !important;
}

.linkedin-url-input-cont svg {
  height: 18px;
  width: 18px;
}

.resume-upload-continue {
  border-radius: 6px;
  width: 180px;
  height: 40px;

  font-size: 14px;
  line-height: 20px;
}

.resume-upload-bottom-section {
  margin-top: 56px;
}

.resume-upload-bottom-section > * {

  font-size: 12px;
  padding: 0;
  background-color: inherit;
}

.upload-container .selected-resume-file span {
  width: auto;
  margin: 0px;
}

.upload-container .closeIcon {
  padding-left: 10px;
}

.upload-container .errorCont {
  position: fixed;
  bottom: 40px;
  right: 40px;
  border: none;
  border-radius: 8px;
  background: #FFE5E6;
  z-index: 1000000;
}
.upload-container .errorCont .ant-alert-message
{
  color: #750507;
}
.upload-container .errorCont .ant-alert-description
{
  color: #750507;
}

.upload-container .errorCont .ant-alert-icon {
  top: 22px;
  left: 20px;
}

.upload-container .errorCont svg{
  height: 32px;
  width: 32px;
}

.less-words-info-alert {
  padding: 16px 64px 16px 80px !important;
  background: #D8F2FE;
  border: none;
  border-radius: 8px;
  color: #045478;
  margin-bottom: 40px;
}
.less-words-info-alert .anticon-warning svg {
  height: 28px;
  width: 32px;
}
.less-words-info-alert .anticon-warning {
  top: calc(50% - 14px);
  left: 28px;
}
.less-words-info-alert .anticon-close svg {
  stroke-width: 40px;
  stroke: #045478;
  width: 17px;
  height: 17px;
  color: #045478;
}
.less-words-info-alert .ant-alert-close-icon {
  top: calc(50% - 7px);
  right: 28px;
}

@media(max-width: 1024px) {
  aside {
    display: none;
  }

  .header-center-title {
    display: none;
  }

  .header-center {
    justify-content: flex-end;
  }

  .header-right {
    display: none;
  }
  
  .header-padding-override {
    padding: 40px 0 !important;
  }
}

@media(max-width: 576px) {
  .profile-card-container {
    padding: 0 24px;
  }
  .profile-card {
    margin: 0;
  }
}

@media only screen and (max-width: 576px) {
  .header-center-progress{
    width: 136px !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/v3/components/RightSidebar/index.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,YAAY;EACZ,2BAA2B;EAC3B,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,UAAU;AACZ;;AAEA;EACE;AACF;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,YAAY;;EAEZ,sBAAsB;EACtB,WAAW;EACX,yBAAyB;EACzB,UAAU;AACZ;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;;EAEhB,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;;EAE1B,iBAAiB;EACjB,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE;AACF;;AAEA;EACE,gBAAgB;;EAEhB,0BAA0B;EAC1B,iBAAiB;EACjB,cAAc;EACd,UAAU;AACZ;CACC,UAAU;;CAEV;EACC,yBAAyB;EACzB,YAAY;EACZ,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,sBAAsB;EACtB,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,YAAY;AACd;;AAEA;EACE;;KAEG;AACL;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;EACpB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,YAAY;EACZ,oBAAoB;AACtB;AACA;EACE,cAAc;AAChB;AACA;EACE,sCAAsC;EACtC,kBAAkB;EAClB,uBAAuB;EACvB,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB;AACF;;AAEA;EACE,yBAAyB;EACzB,qCAAqC;AACvC;;AAEA;EACE,gBAAgB;;EAEhB,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;AACrB;;;AAGA;EACE,OAAO;EACP,WAAW;EACX,gBAAgB;EAChB,qBAAqB;EACrB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,aAAa;AACf;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,OAAO;EACP,cAAc;EACd,eAAe;AACjB;AACA;EACE,YAAY;AACd;;AAEA;;EAEE,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;EACd,6BAA6B;AAC/B;;AAEA;;EAEE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,2CAA2C;EAC3C,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;AACf;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,eAAe;EACf,iBAAiB;EACjB,UAAU;EACV,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,YAAY;EACZ,qCAAqC;EACrC,eAAe;AACjB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,YAAY;;EAEZ,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,eAAe;EACf,UAAU;EACV,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;;EAEE,cAAc;AAChB;AACA;;EAEE,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,uCAAuC;EACvC,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,WAAW;AACb;AACA;EACE,qBAAqB;EACrB,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;AACA;EACE,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,eAAe;EACjB;EACA;IACE,SAAS;EACX;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;AACF","sourcesContent":[".host-div {\n  display: flex;\n  flex-direction: row;\n  height: 100vh;\n  background: #F8F8F8;\n}\n.title-1 {\n  text-align: left;\n  font-size: 20px !important;\n  height: 26px;\n  font-weight: 500 !important;\n  letter-spacing: 0;\n  margin-top: 48px;\n  margin-bottom: 0;\n  color: #444444;\n  opacity: 1\n}\n\n.title-spacing {\n  margin-top: 24px\n}\n\n.input-info-col {\n  margin-right: 24px\n}\n\n.top-heading {\n  /* position: relative; */\n  font-size: 28px;\n  min-height: 37px;\n  font-weight: 500;\n  margin-top: 12px;\n  margin-bottom: 0;\n  letter-spacing: 0;\n  color: #212121;\n  opacity: 1;\n}\n\n.header-padding-override {\n  padding: 40px 20px !important\n}\n\n.top-title {\n  text-align: left;\n  font-size: 12px;\n  height: 16px;\n\n  letter-spacing: 0.96px;\n  color: #CCC;\n  text-transform: uppercase;\n  opacity: 1;\n}\n\n.top-description {\n  /* position: relative; */\n  text-align: left;\n\n  font-size: 16px;\n  letter-spacing: 0;\n  color: #888;\n  margin-top: 40px;\n  margin-bottom: 0;\n  min-height: 45px;\n  height: auto;\n  opacity: 1;\n}\n\n.progress-color {\n  color: grey !important;\n}\n\n.warning-msg {\n  text-align: left;\n  font-size: 11px !important;\n\n  letter-spacing: 0;\n  color: #AAAAAA;\n  opacity: 1;\n}\n\n.horizontal-line {\n  margin-top: 40px;\n  margin-bottom: 0;\n  border-top: 1px solid #eee;\n  border-bottom: none;\n}\n\n.remove-icon:hover {\n  cursor: pointer;\n}\n\n.profile-card-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  overflow-y: auto;\n  position: relative;\n  padding: 0 48px;\n}\n\n.profile-card-container .ant-radio-checked:after {\n  content: initial;\n}\n\n.flex {\n  flex: 1 0 0;\n}\n\n.logo-header {\n  width: 80px;\n  height: auto;\n  opacity: 1;\n}\n\n.profile-card {\n  width: 100%;\n  max-width: 602px;\n  padding: 0 !important;\n  background: #F8F8F8;\n}\n\n.profile-card > .ant-card-body {\n  padding: 0 !important\n}\n\n.btn-link-font {\n  text-align: left;\n\n  font-size: 16px !important;\n  letter-spacing: 0;\n  color: #212121;\n  opacity: 1;\n}\n /* Aside */\n\n aside{\n  background-color: #EEEEEE;\n  width: 366px;\n  height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  box-sizing: border-box;\n  padding: 0 !important;\n  overflow: hidden;\n  overflow-y: auto;\n  border-left: 1px solid #eee;\n}\n\n.ant-input::placeholder, .ant-input:placeholder-shown {\n  text-overflow: ellipsis;\n  color: #bfbfbf;\n  font-size: 16px;\n  opacity: 0.6;\n}\n\n@media only screen and (max-width: 1400px){ \n  /* aside{\n    width: 260px;\n  } */\n}\n\n.aside_logo {\n  margin-top: 48px;\n  margin-bottom: 20px;\n  align-self: flex-end;\n  width: 55px;\n  height: auto;\n}\n\n#aside_tagline {\n  font-size: 20px;\n  font-weight: 500;\n  color: #000000;\n  text-align: right;\n  width: 180px;\n  align-self: flex-end;\n}\n#aside_cards{\n  margin: 24px 0;\n}\n.aside_card{\n  box-shadow: 0 2px 4px rgba(0,0,0,0.08);\n  padding: 12px 16px;\n  background-color: white;\n  border-radius: 4px;\n  color: #444;\n  font-size: 14px;\n  margin-bottom: 16px;\n}\n#aside_illustration{\n  margin-bottom: 56px;\n  width: 150%;\n  height: auto;\n}\n\n.section-title {\n  display: flex;\n  align-items: baseline;\n}\n.section-warning {\n  margin-top: 48px;\n  margin-left: 18px;\n  text-align: left;\n  height: 26px;\n  letter-spacing: 0;\n  margin-bottom: 0;\n  opacity: 1\n}\n\n.link-text {\n  color: #AAAAAA !important;\n  text-decoration: underline !important;\n}\n\n.summary-description {\n  text-align: left;\n  \n  font-size: 14px;\n  letter-spacing: 0;\n  color: #888888 !important;\n  margin-top: 24px;\n  margin-bottom: 24px;\n}\n\n\n.header-center{\n  flex: 1;\n  width: 100%;\n  max-width: 602px;\n  padding: 0 !important;\n  display: flex;\n  align-items: center;\n}\n\n.header-left, .header-right {\n  width: 80px;\n  display: flex;\n}\n\n.header-right {\n  justify-content: flex-end;\n}\n\n.header-center-title{\n  flex: 1;\n  color: #888888;\n  font-size: 16px;\n}\n.header-center-progress{\n  width: 220px;\n}\n\n.resume-upload-heading {\n\n  font-size: 20px;\n  line-height: 30px;\n  letter-spacing: 0.25px;\n  color: #212121;\n  margin-bottom: 8px !important;\n}\n\n.resume-upload-description {\n\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 22px;\n  letter-spacing: 0.15px;\n  color: #212121;\n  margin-bottom: 32px;\n}\n\n.upload-container {\n  background: #FFFFFF;\n  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.12);\n  border-radius: 8px;\n  padding: 24px;\n}\n\n.upload-container .ant-upload.ant-upload-drag {\n  background: #F8F8F8;\n  border-radius: 6px;\n  border: 1px solid #56A8F7;\n  height: 180px;\n}\n.resume-upload-cont {\n  margin-bottom: 32px;\n}\n\n.resume-upload-cont.error .ant-upload.ant-upload-drag {\n  border: 1px solid #F86567;\n}\n\n.upload-container .error {\n\n  font-size: 12px;\n  line-height: 17px;\n  color: red;\n  margin-top: 4px;\n  display: block;\n}\n\n.linkedin-url-input-cont{\n  margin-bottom: 16px;\n}\n\n.linkedin-url-input-cont input\n{\n  height: 38px;\n  padding: 9px 12px 7px 36px !important;\n  font-size: 14px;\n}\n\n.linkedin-url-input-cont.error input {\n  border: 1px solid #F86567 !important;\n}\n\n.linkedin-url-input-cont svg {\n  height: 18px;\n  width: 18px;\n}\n\n.resume-upload-continue {\n  border-radius: 6px;\n  width: 180px;\n  height: 40px;\n\n  font-size: 14px;\n  line-height: 20px;\n}\n\n.resume-upload-bottom-section {\n  margin-top: 56px;\n}\n\n.resume-upload-bottom-section > * {\n\n  font-size: 12px;\n  padding: 0;\n  background-color: inherit;\n}\n\n.upload-container .selected-resume-file span {\n  width: auto;\n  margin: 0px;\n}\n\n.upload-container .closeIcon {\n  padding-left: 10px;\n}\n\n.upload-container .errorCont {\n  position: fixed;\n  bottom: 40px;\n  right: 40px;\n  border: none;\n  border-radius: 8px;\n  background: #FFE5E6;\n  z-index: 1000000;\n}\n.upload-container .errorCont .ant-alert-message\n{\n  color: #750507;\n}\n.upload-container .errorCont .ant-alert-description\n{\n  color: #750507;\n}\n\n.upload-container .errorCont .ant-alert-icon {\n  top: 22px;\n  left: 20px;\n}\n\n.upload-container .errorCont svg{\n  height: 32px;\n  width: 32px;\n}\n\n.less-words-info-alert {\n  padding: 16px 64px 16px 80px !important;\n  background: #D8F2FE;\n  border: none;\n  border-radius: 8px;\n  color: #045478;\n  margin-bottom: 40px;\n}\n.less-words-info-alert .anticon-warning svg {\n  height: 28px;\n  width: 32px;\n}\n.less-words-info-alert .anticon-warning {\n  top: calc(50% - 14px);\n  left: 28px;\n}\n.less-words-info-alert .anticon-close svg {\n  stroke-width: 40px;\n  stroke: #045478;\n  width: 17px;\n  height: 17px;\n  color: #045478;\n}\n.less-words-info-alert .ant-alert-close-icon {\n  top: calc(50% - 7px);\n  right: 28px;\n}\n\n@media(max-width: 1024px) {\n  aside {\n    display: none;\n  }\n\n  .header-center-title {\n    display: none;\n  }\n\n  .header-center {\n    justify-content: flex-end;\n  }\n\n  .header-right {\n    display: none;\n  }\n  \n  .header-padding-override {\n    padding: 40px 0 !important;\n  }\n}\n\n@media(max-width: 576px) {\n  .profile-card-container {\n    padding: 0 24px;\n  }\n  .profile-card {\n    margin: 0;\n  }\n}\n\n@media only screen and (max-width: 576px) {\n  .header-center-progress{\n    width: 136px !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
